import MoveTo from "moveto";

let tolerance, offset


function resize() {
    if (window.innerWidth > 1024) {
        offset = innerHeight * 0.02

        let menu = document.querySelector(".Sidebard__menu"),
            ul = document.querySelector(".Sidebard__menu ul")

        menu.style.paddintTop = "0px"

        tolerance = (menu.offsetHeight - ul.offsetHeight) / 2 - offset

    } else {
        offset = 0
        tolerance = window.innerWidth * 0.181134259259
    }
    // console.log(tolerance)
    if (moveTo) {
        moveTo.options.tolerance = tolerance
    }
    // console.log(tolerance)
}

export const getTolerance = () => {
    return { tolerance, offset }
}

const moveTo = new MoveTo({
    tolerance,
    duration: 300
});

// console.log(moveTo)

export const movetoInit = () => {

    if (document.querySelector(".Sidebard")) {
        resize()

        window.addEventListener("resize", () => {
            resize()
        })

        let triggers
        triggers = document.querySelectorAll('main a[href^="#"]');

        for (var i = 0; i < triggers.length; i++) {
            moveTo.registerTrigger(triggers[i]);
        }
    }
}
